import React from 'react';

import { ActionIcon, Alert, Flex, List, Modal, ScrollArea, Text, Title } from '@mantine/core';
import { IconAlertCircle, IconArrowRight } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { ROUTE_LINKS } from 'shared/constants/route-links';
import { Resource } from 'shared/interfaces/Resource';

interface ConflictErrorModalProps {
  errorModalOpened: boolean;
  conflictedResources: Resource[];
  onClose?: () => void;
}
export function GoogleDriveAccountConflictErrorModal({
  errorModalOpened,
  conflictedResources,
  onClose
}: ConflictErrorModalProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Modal
      title={<Title order={3}>{t('RESOURCES_PAGE.ERROR_MODAL.CONFLICT.TITLE')}</Title>}
      opened={errorModalOpened}
      size={500}
      onClose={() => onClose?.()}>
      {conflictedResources.length > 0 && (
        <Alert icon={<IconAlertCircle size={16} />} title={t('GOOGLE_DRIVE.CONFLICT_MODAL.TITLE')} color="red">
          <ScrollArea style={{ height: 100 }}>
            <List>
              {conflictedResources.map((resource) => (
                <List.Item key={resource._id}>
                  <Flex direction="row" align="center">
                    <Text mr={10}>{resource.fileName}</Text>
                    <ActionIcon onClick={() => navigate(`${ROUTE_LINKS.googleDriveViewer}/${resource._id}`)}>
                      <IconArrowRight />
                    </ActionIcon>
                  </Flex>
                </List.Item>
              ))}
            </List>
          </ScrollArea>
        </Alert>
      )}
    </Modal>
  );
}
